<div
  qaiAccordionItem
  [expanded]="expanded()"
  (expandedChange)="onExpandedChange($event)"
  #item="qaiAccordionItem"
  class="panel"
>
  <!-- Header: clicking anywhere (title or chevron) toggles the panel -->
  <button qaiAccordionHeader qaiAccordionToggle class="panel-header">
    <span class="panel-title">{{ 'simulationBuilder.KC_TIPS_TITLE' | transloco }}</span>
    <qai-icon [kind]="item.expanded() ? 'chevron-up' : 'chevron-down'" size="16px" />
  </button>

  <!-- Body: bullets + verb definitions -->
  <div qaiAccordionBody class="panel-body">
    <ul class="tips-list">
      <li>{{ 'simulationBuilder.KC_TIPS_BULLET_1' | transloco }}</li>
      <li>{{ 'simulationBuilder.KC_TIPS_BULLET_2' | transloco }}</li>
      <li>{{ 'simulationBuilder.KC_TIPS_BULLET_3' | transloco }}</li>
      <li>{{ 'simulationBuilder.KC_TIPS_BULLET_4' | transloco }}</li>
    </ul>

    <div class="definitions">
      <!-- State -->
      <div class="definition-row">
        <span class="badge">{{ 'simulationBuilder.KC_TIPS_STATE_BADGE' | transloco }}</span>
        <p class="definition-text">
          {{ 'simulationBuilder.KC_TIPS_STATE_DESCRIPTION' | transloco }}
          <em>{{ 'simulationBuilder.KC_TIPS_STATE_EXAMPLE' | transloco }}</em>
        </p>
      </div>

      <!-- Mention -->
      <div class="definition-row">
        <span class="badge">{{ 'simulationBuilder.KC_TIPS_MENTION_BADGE' | transloco }}</span>
        <p class="definition-text">
          {{ 'simulationBuilder.KC_TIPS_MENTION_DESCRIPTION' | transloco }}
          <em>{{ 'simulationBuilder.KC_TIPS_MENTION_EXAMPLE' | transloco }}</em>
        </p>
      </div>

      <!-- Acknowledge -->
      <div class="definition-row">
        <span class="badge">{{ 'simulationBuilder.KC_TIPS_ACKNOWLEDGE_BADGE' | transloco }}</span>
        <p class="definition-text">
          {{ 'simulationBuilder.KC_TIPS_ACKNOWLEDGE_DESCRIPTION' | transloco }}
          <em>{{ 'simulationBuilder.KC_TIPS_ACKNOWLEDGE_EXAMPLE' | transloco }}</em>
        </p>
      </div>
    </div>
  </div>
</div>
